<template>
    <div>
        <div class="footer">
            <footer class="mt-4 pin-b bg-grey-light p-4 pb-2"
                :class="{'absolute w-full': absoluteFooter}">
                <div class="flex flex-col sm:flex-row mx-3 sm:mx-auto sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl justify-between p-3">
                    <div class="flex-col bg-white mt-4 mb-2 sm:mt-0 sm:hidden rounded-lg">
                        <div class="mx-4">
                            <h3 class="mt-2 text-blue">Service Center Login</h3>
                            <button @click="$refs.modal.open()"
                                class="text-black flex items-center my-2 hover:text-blue">
                                <span class="mr-2 text-sm font-bold">LOGIN</span>
                                <IconArrowRight/>
                            </button>
                        </div>
                    </div>
                    <div class="flex-col lg:w-1/4">
                        <div class="my-6 xs:mr-4 xs:ml-0 sm:mt-2 flex-1">
                            <router-link to="/warranty"
                                class="no-underline text-black hover:text-blue">
                                Certified Nationwide Warranty
                            </router-link>
                        </div>
                        <div class="my-6 xs:mr-4 xs:ml-0 sm:mt-2 flex-1">
                            <router-link to="/car-maintenance"
                                class="no-underline text-black hover:text-blue">
                                Car Maintenance 101
                            </router-link>
                        </div>
                        <div class="my-6 xs:mr-4 xs:ml-0 sm:mt-2 flex-1">
                            <router-link to="/right-shop"
                                class="no-underline text-black hover:text-blue">
                                Choose the Right Shop
                            </router-link>
                        </div>
                    </div>
                    <div class="flex-col mt-4 hidden sm:flex xs:mt-0 sm:ml-3 lg:ml-0 lg:w-1/3">
                        <div class="mx-4 bg-white p-4 rounded-lg">
                            <h3 class="mt-2 text-blue">Service Center Login</h3>
                            <button @click="$refs.modal.open()"
                                class="text-black flex items-center my-2 hover:text-blue">
                                <span class="mr-2 text-sm font-bold">LOGIN</span>
                                <IconArrowRight/>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="py-4 mx-3 sm:mx-auto sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl justify-between px-3">
                    <p class="text-xs text-left"><span v-html="copyrightSymbol"></span> {{ copyrightYear }} Certified Auto Repair v {{ version }}</p>
                </div>
            </footer>
        </div>
        <Modal ref="modal"
            :overlayClose="true"
            :overflow="false"
            :ariaLabelledBy="'modalTitle'"
            :ariaDescribedBy="'modalContent'">
            <div slot="title">
                <h2 id="modalTitle" class="text-xl">Member Login Moved</h2>
            </div>
            <div slot="content">
                <div id="modalContent" class="max-w-md mb-6">
                    <p class="mt-3 mb-6 mx-6 sm:mx-12 md:mx-16 text-left">
                        The Certified Auto Repair Member Administration pages have moved to our Professional site at
                        www.oreillypro.com This move provides an updated and easier to use interface for our
                        Certified Auto Repair members. You will need to use your O'Reilly Pro login to continue.
                    </p>
                    <a :href="oreillyProUrl"
                        @click="$refs.modal.close()"
                        title="O'Reilly Pro Login"
                        aria-label="The O'Reilly Pro login for CARC members"
                        class="btn btn-white border font-semibold rounded shadow-md mx-1 w-32">
                        OK
                    </a>
                    <button @click="$refs.modal.close()"
                        class="btn-red mx-1 w-32 rounded">
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios';
import IconArrowRight from 'icon/arrow-right.svg';
import Modal from '@/js/components/Modal.vue';

export default {
    components: {
        IconArrowRight,
        Modal
    },
    data() {
        return {
            version: 'Unknown Version',
            absoluteFooter: false,
            copyrightSymbol: '&copy;',
            copyrightYear: 2020
        };
    },
    computed: {
        oreillyProUrl() {
            if (process.env.NODE_ENV === 'test') {
                return 'https://www-test-1.oreillypro.com/FirstCallOnline/login';
            } if (process.env.NODE_ENV === 'development') {
                return 'https://www-dev-1.oreillypro.com/FirstCallOnline/login';
            }
            return 'https://www.oreillypro.com/FirstCallOnline/login';
        }
    },
    methods: {
        getVersion() {
            return axios.get('api/version')
                .then((response) => {
                    this.version = response.data.version;
                }).catch(() => {
                    this.version = 'Unknown Version';
                });
        },
        getCopyrightYear() {
            return axios.get('api/copyright')
                .then((response) => {
                    this.copyrightYear = new Date(response.data).getFullYear();
                }).catch(() => {
                    this.copyrightYear = new Date().getFullYear();
                });
        },

        stickToBottom() {
            const currentPage = document.getElementById('app').firstElementChild;
            if (currentPage.clientHeight < window.innerHeight) {
                this.absoluteFooter = true;
            } else {
                this.absoluteFooter = false;
            }
        }
    },
    mounted() {
        this.getVersion();
        this.getCopyrightYear();
        this.stickToBottom();
    }
};
</script>
